import ApiClient from "Store/client";

/*
-------------------------------------------
---------- MAIN CLASSROOMS  API -----------
-------------------------------------------
*/
export const deleteClassroomApi = (body) =>
  ApiClient(`api/commands/delete-class`, { method: "DELETE", body });

export const fetchClassroomsApi = (queryString) =>
  ApiClient<Classroom[]>(`api/classrooms${queryString}`);

export const fetchClassroomApi = (classroomId) =>
  ApiClient<Partial<Classroom>>(`api/classrooms/${classroomId}`);

export const fetchClassroomStatsApi = (classroomId) =>
  ApiClient(`api/classrooms/${classroomId}/stats`);

export const createClassroomApi = (body) =>
  ApiClient("api/commands/create-classroom", { body, method: "POST" });

export const updateClassroomApi = (body) =>
  ApiClient(`api/commands/update-class`, {
    method: "PATCH",
    body
  });

export const removeInstructorFromClassroomApi = (body) =>
  ApiClient(`api/commands/remove-instructor-from-class`, {
    method: "DELETE",
    body
  });
export const fetchClassroomReportPDFApi = (classId, body) =>
  ApiClient<Blob>(`api/classrooms/${classId}/overall-strengths-and-weaknesses-report`, {
    method: "POST",
    body,
    type: "blob"
  });

export const fetchClassroomSummaryApi = (classroom_id) =>
  ApiClient<ClassSummary>(`api/classrooms/${classroom_id}/summary`);

export const addInstructorToClassroomApi = (body) =>
  ApiClient(`api/commands/add-instructor-to-class`, {
    method: "PATCH",
    body,
    type: "text"
  });
export const updateClassroomArchivedApi = (body) =>
  ApiClient("api/commands/update-class-archived", { body, method: "PATCH", type: "text" });

export const fetchClassroomStudentsApi = (classroomId, queryString) =>
  ApiClient<Student[]>(`api/students${queryString}&classroom=${classroomId}`);

export const fetchClassroomOverdueStats = (classroomId: string) =>
  ApiClient(`api/classrooms/${classroomId}/summary/overdue`);

export const fetchClassroomProblemsStats = (classroomId: string) =>
  ApiClient(`api/classrooms/${classroomId}/summary/problems`);
/*
-------------------------------------------
---------- LESSONS CLASSROOMS  API -----------
-------------------------------------------
*/
export const fetchClassroomLessonListApi = (classroomId, queryString) =>
  ApiClient<ClassroomLesson[]>(`api/classrooms/${classroomId}/lessons${queryString}`);

export const fetchClassroomLessonApi = (classroomId, lessonId) =>
  ApiClient<LessonTemplate>(`api/classrooms/${classroomId}/lessons/${lessonId}`);

export const assignLessonToClassroomApi = (body) =>
  ApiClient(`api/commands/assign-classroom-lessons`, {
    method: "POST",
    body
  });

export const rescheduleClassroomLessonsApi = (body) =>
  ApiClient(`api/commands/reschedule-classroom-lessons`, {
    method: "PATCH",
    body,
    type: "text"
  });

export const unassignLessonFromClassroomApi = (body: UnassignLessonsFromClassRequest) =>
  ApiClient(`api/commands/unassign-classroom-lessons`, {
    method: "POST",
    body,
    type: "text"
  });

/*
-------------------------------------------
---------- WORKSHEETS CLASSROOMS  API -----------
-------------------------------------------
*/
export const fetchClassroomWorksheetListApi = (classroomId, queryString) =>
  ApiClient<ClassroomWorksheet[]>(`api/classrooms/${classroomId}/worksheets${queryString}`);

export const fetchClassroomWorksheetByCategoryApi = (classroomId, parameters) =>
  ApiClient<WorksheetTemplate[]>(
    `api/classrooms/${classroomId}/categories/worksheets${parameters}`
  );

export const fetchClassroomWorksheetApi = (classroomId, classroomWorksheetId) =>
  ApiClient<ClassroomWorksheet[]>(
    `api/classrooms/${classroomId}/worksheets/${classroomWorksheetId}`
  );

export const unassignWorksheetFromClassApi = (body: UnassignWorksheetFromClassRequest) =>
  ApiClient(`api/commands/unassign-classroom-worksheets`, {
    method: "POST",
    body,
    type: "text"
  });

export const assignWorksheetToClassroomApi = (body) =>
  ApiClient(`api/commands/assign-classroom-worksheets`, {
    method: "POST",
    body,
    type: "text"
  });

export const rescheduleClassroomWorksheetsApi = (body) =>
  ApiClient(`api/commands/reschedule-classroom-worksheets`, {
    method: "PATCH",
    body
  });
/*
-------------------------------------------
---------- TESTS CLASSROOMS  API -----------
-------------------------------------------
*/
export const fetchClassroomTestListApi = (classroom, queryString) =>
  ApiClient<Test[]>(`api/classrooms/${classroom}/tests${queryString}`);

export const fetchClassroomTestApi = (classroom, testId) =>
  ApiClient<Test>(`api/classrooms/${classroom}/tests/${testId}`);

export const fetchClassroomTestSectionApi = (classroom, testId, sectionId) =>
  ApiClient<Test>(`api/classrooms/${classroom}/tests/${testId}/section/${sectionId}`);

export const updateClassroomTestSectionsApi = (body) =>
  ApiClient(`api/commands/update-classroom-test-sections`, {
    method: "PATCH",
    body,
    type: "text"
  });
export const assignTestToClassroomApi = (body) =>
  ApiClient(`api/commands/assign-classroom-tests`, { method: "POST", body });

export const updateClassroomTestNotifyApi = (body) =>
    ApiClient(`api/commands/update-classroom-test-notify`, {
        method: "PATCH",
        body,
        type: "text"
    });
export const rescheduleClassroomTestsApi = (body) =>
    ApiClient(`api/commands/reschedule-classroom-tests`, {
        method: "PATCH",
        body,
        type: "text"
    });
export const unassignTestFromClassroomApi = (body) =>
  ApiClient(`api/commands/unassign-classroom-tests`, {
    method: "POST",
    body,
    type: "text"
  });
/*
-------------------------------------------
---------- SESSIONS CLASSROOMS  API -----------
-------------------------------------------
*/
export const assignSessionToClassroomApi = (body) =>
  ApiClient(`api/commands/create-classroom-session`, {
    method: "POST",
    body
  });

export const updateClassroomSessionApi = (body) =>
  ApiClient(`api/commands/update-classroom-session`, {
    method: "PATCH",
    body
  });

export const deleteClassroomSessionApi = (body) =>
  ApiClient(`api/commands/delete-classroom-session`, {
    method: "DELETE",
    body
  });
/*
-------------------------------------------
----------- ------------------- -----------
-------------------------------------------
*/

export const fetchClassroomCalendarLessons = (classroomId) =>
  ApiClient(`api/classrooms/${classroomId}/lessons_calendar`);
export const fetchClassroomCalendarWorksheets = (classroomId) =>
  ApiClient(`api/classrooms/${classroomId}/worksheets_calendar`);
export const fetchClassroomCalendarTests = (classroomId) =>
  ApiClient(`api/classrooms/${classroomId}/tests_calendar`);

export const assignClassroomAssignmentToStudent = (body, type) =>
  ApiClient(`api/commands/assign-classroom-${type}-to-student`, { method: "POST", body });
